import Vue from "vue";
import Router from "vue-router";
import Page from "./views/Page.vue";
import Login from "./views/Login.vue";
import Dashboard from "./views/Dashboard.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        automatic: true,
      },
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {
        loginRequired: true,
        automatic: true,
      },
    },
    {
      path: "/*",
      name: "pages",
      component: Page,
    },
  ],

  // scrollBehavior(to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition;
  //   }
  //   if (from.path !== to.path) {
  //     return { x: 0, y: 0 };
  //   }

  //   let existing = {
  //     x: window.scrollX,
  //     y: window.scrollY
  //   };
  //   console.log(`Existing scroll`, existing);
  //   return new Promise(resolve => {
  //     setTimeout(() => {
  //       resolve(existing);
  //     }, 0);
  //   });

  // },

  scrollBehavior(to: any, from: any, savedPosition: any) {
    return new Promise((resolve: any, reject: any) => {
      if (from && to.path != from.path) {
        setTimeout(() => {
          resolve({ x: 0, y: 0 });
        }, 500);
      }
    });
  },
});
